module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "CH-T"
  }, [_c('strong', [_vm._v("Bright Stripe Pillows")])]), _vm._v(" "), _c('p', {
    staticClass: "INTRO1"
  }, [_vm._v("These shaped pillows with their simple yet distinctive stripe pattern are much easier to knit than you might think.")]), _vm._v(" "), _c('h4', {
    staticClass: "CHD"
  }, [_c('strong', [_c('em', [_vm._v("Skill Level-Easy")])])]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/Images/8-1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "SBDIV"
  }, [_c('h4', {
    staticClass: "MLAHD"
  }, [_vm._v("You Will Need")]), _vm._v(" "), _c('h4', {
    staticClass: "MLAHD"
  }, [_vm._v("For the Bolster Pillow")]), _vm._v(" "), _c('h5', {
    staticClass: "MLBHD"
  }, [_vm._v("Yarn")]), _vm._v(" "), _c('p', {
    staticClass: "ML-BL1-1st"
  }, [_vm._v("•  1 × 1"), _c('span', {
    staticClass: "fraction"
  }, [_c('sup', [_vm._v("3")]), _vm._v("⁄"), _c('sub', [_vm._v("4")])]), _vm._v("oz (50g) ball of light-weight (DK) or medium-weight (aran) yarn in each of seven shades of dark red and burgundy ("), _c('span', {
    staticClass: "C_01bBoldbItalicsOBold"
  }, [_c('strong', [_vm._v("A")])]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ML-BL1"
  }, [_vm._v("•  1 × 1"), _c('span', {
    staticClass: "fraction"
  }, [_c('sup', [_vm._v("3")]), _vm._v("⁄"), _c('sub', [_vm._v("4")])]), _vm._v("oz (50g) ball of light-weight (DK)")]), _vm._v(" "), _c('p', {
    staticClass: "ML-BL1"
  }, [_vm._v("•  or medium-weight (aran) yarn in each of")]), _vm._v(" "), _c('p', {
    staticClass: "ML-BL1"
  }, [_vm._v("•  three shades of scarlet and light red and")]), _vm._v(" "), _c('p', {
    staticClass: "ML-BL1-last"
  }, [_vm._v("•  1 × "), _c('span', {
    staticClass: "fraction"
  }, [_c('sup', [_vm._v("7")]), _vm._v("⁄"), _c('sub', [_vm._v("8")])]), _vm._v("oz (25g) ball of fine-weight (4ply) metallic yarn in red ("), _c('strong', [_vm._v("B")]), _vm._v(")")]), _vm._v(" "), _c('h5', {
    staticClass: "MLBHD"
  }, [_vm._v("Knitting Needles")]), _vm._v(" "), _c('p', {
    staticClass: "ML-BL1-1st"
  }, [_vm._v("•  One set size 6 (4mm) double-pointed needles (dpns)")]), _vm._v(" "), _c('p', {
    staticClass: "ML-BL1-last"
  }, [_vm._v("•  One size 6 (4mm) circular needle 16in (40cm) long")]), _vm._v(" "), _c('h5', {
    staticClass: "MLBHD"
  }, [_vm._v("Other Materials")]), _vm._v(" "), _c('p', {
    staticClass: "ML-BL1-1st"
  }, [_vm._v("•  Stitch markers")]), _vm._v(" "), _c('p', {
    staticClass: "ML-BL1-last"
  }, [_vm._v("•  Bolster cushion pad 7in (18cm) diameter and 18"), _c('span', {
    staticClass: "fraction"
  }, [_c('sup', [_vm._v("1")]), _vm._v("⁄"), _c('sub', [_vm._v("2")])]), _vm._v("in (47cm) long")])]), _vm._v(" "), _c('h2', {
    staticClass: "AHD"
  }, [_c('strong', [_vm._v("Finished Measurements")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("7in (18cm) diameter and 18"), _c('span', {
    staticClass: "fraction"
  }, [_c('sup', [_vm._v("1")]), _vm._v("⁄"), _c('sub', [_vm._v("2")])]), _vm._v("in (47cm) long")]), _vm._v(" "), _c('h2', {
    staticClass: "AHD"
  }, [_c('strong', [_vm._v("Gauge")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("22 sts and 28 rows to 4in (10cm) measured over st st (1 row k, 1 row p) using size 6 (4mm) needles and A")]), _vm._v(" "), _c('h2', {
    staticClass: "AHD"
  }, [_c('strong', [_vm._v("Knit Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("The bolster has two circular motifs for the ends, linked by a tube of circular knitting between. Worked in a simple stripe pattern, it is a great project to begin using double-pointed and circular needles. You use only knit stitch, and the increases are simply worked by knitting into the front and back of a stitch.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_c('strong', [_vm._v("Yarns A:")]), _vm._v(" Use these in any order, using one yarn for each wide stripe. For the project as knitted, seven dark, rich reds in light-weight (DK) and medium-weight (aran) yarns are used: two wool yarns in light and dark raspberry, three shades of dark red, a textured yarn in wine, and a dark burgundy.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_c('strong', [_vm._v("Yarns B:")]), _vm._v(" The narrow stripes are worked using four yarns – two wool yarns in bright scarlet and fiery red, a pale red mercerized cotton, and a glittery metallic red yarn. These can also be used randomly, although for the project as knitted the metallic yarn is used for every third stripe and the others are mixed for the two stripes between.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("Use two strands of metallic yarn together throughout. Make sure that you work through both strands for each stitch.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("Knit Your Bolster")]), _vm._v(" "), _c('h3', {
    staticClass: "BHD"
  }, [_c('strong', [_vm._v("BOLSTER ENDS (MAKE 2}")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("Using size 6 (4mm) double-pointed needles and A, cast on 8 sts and arrange them on four needles.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_c('strong', [_vm._v("Round 1")]), _vm._v(" Using A, k8. Place a marker to show end of rnd, slip this marker on every rnd.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_c('strong', [_vm._v("Round 2")]), _vm._v(" Using A, (kf&b) into each st. 16 sts.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_c('strong', [_vm._v("Rounds 3, 4 and 5")]), _vm._v(" Using A, k to end.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_c('strong', [_vm._v("Round 6")]), _vm._v(" Using A, (kf&b) into each st. 32 sts.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_c('strong', [_vm._v("Rounds 7, 8 and 9")]), _vm._v(" Using A, k to end.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_c('strong', [_vm._v("Round 10")]), _vm._v(" Using A, *k1, kf&b; rep from * to end. 48 sts.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_c('strong', [_vm._v("Rounds 11 and 12")]), _vm._v(" Using B, k to end.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_c('strong', [_vm._v("Round 13")]), _vm._v(" Using A, k to end.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_c('strong', [_vm._v("Round 14")]), _vm._v(" Using A, *k2, kf&b; rep from * to end. 64 sts.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_c('strong', [_vm._v("Rounds 15, 16 and 17")]), _vm._v(" Using A, k to end.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_c('strong', [_vm._v("Round 18")]), _vm._v(" Using A, *k3, kf&b; rep from * to end. 80 sts.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_c('strong', [_vm._v("Rounds 19, 20 and 21")]), _vm._v(" Using A, k to end.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_c('strong', [_vm._v("Round 22")]), _vm._v(" Using A, *k4, kf&b; rep from * to end. 96 sts.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_c('strong', [_vm._v("Rounds 23 and 24")]), _vm._v(" Using B, k to end.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_c('strong', [_vm._v("Round 25")]), _vm._v(" Using A, k to end.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_c('strong', [_vm._v("Round 26")]), _vm._v(" Using A, *k5, kf&b; rep from * to end. 112 sts.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_c('strong', [_vm._v("Rounds 27 and 28")]), _vm._v(" Using A, k to end.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("Bind off loosely.")]), _vm._v(" "), _c('h3', {
    staticClass: "BHD"
  }, [_c('strong', [_vm._v("BOLSTER TUBE")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("With RS of work facing, using size 6 (4mm) circular needle and A, pick up and knit 112 sts around the edge of one bolster end. Place a marker to show end of round.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("Using A, knit 9 rounds.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("**Using B, knit 2 rounds.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("Using A, knit 10 rounds.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("Rep from ** until side measures approx 18"), _c('span', {
    staticClass: "fraction"
  }, [_c('sup', [_vm._v("1")]), _vm._v("⁄"), _c('sub', [_vm._v("2")])]), _vm._v("in (47cm) long, ending with 10 rows of A.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("Bind off loosely.")]), _vm._v(" "), _c('h2', {
    staticClass: "AHD"
  }, [_c('strong', [_vm._v("Finish Your Bolster")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("Sew in all ends neatly. Press according to instructions on ball bands. Insert bolster cushion pad. Sew circular end to bound-off edge of side.")]), _vm._v(" "), _c('div', {
    staticClass: "SBDIV"
  }, [_c('h4', {
    staticClass: "MLAHD"
  }, [_vm._v("You Will Need")]), _vm._v(" "), _c('h4', {
    staticClass: "MLAHD"
  }, [_vm._v("For the Round Pillow")]), _vm._v(" "), _c('h5', {
    staticClass: "MLBHD"
  }, [_vm._v("Yarn")]), _vm._v(" "), _c('p', {
    staticClass: "ML-BL1-1st"
  }, [_vm._v("•  2 × 1"), _c('span', {
    staticClass: "fraction"
  }, [_c('sup', [_vm._v("3")]), _vm._v("⁄"), _c('sub', [_vm._v("4")])]), _vm._v("oz (50g) balls of light-weight (DK) yarn (131yd/120m per ball) in light purple ("), _c('strong', [_vm._v("A")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ML-BL1"
  }, [_vm._v("•  1 × 1"), _c('span', {
    staticClass: "fraction"
  }, [_c('sup', [_vm._v("3")]), _vm._v("⁄"), _c('sub', [_vm._v("4")])]), _vm._v("oz (50g) ball of light-weight (DK) yarn (175yd/160m per ball) in dark purple ("), _c('strong', [_vm._v("B")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "ML-BL1-last"
  }, [_vm._v("•  2 × "), _c('span', {
    staticClass: "fraction"
  }, [_c('sup', [_vm._v("7")]), _vm._v("⁄"), _c('sub', [_vm._v("8")])]), _vm._v("oz (25g) balls of light-weight (DK) metallic yarn (110yd/100m per ball) in purple ("), _c('strong', [_vm._v("C")]), _vm._v(")")]), _vm._v(" "), _c('h5', {
    staticClass: "MLBHD"
  }, [_vm._v("Knitting Needles")]), _vm._v(" "), _c('p', {
    staticClass: "ML-BL1-1st"
  }, [_vm._v("•  One set size 6 (4mm) double-pointed needles (dpns)")]), _vm._v(" "), _c('p', {
    staticClass: "ML-BL1"
  }, [_vm._v("•  One size 6 (4mm) circular needle 16in (40cm) long")]), _vm._v(" "), _c('h5', {
    staticClass: "MLBHD"
  }, [_vm._v("Other Materials")]), _vm._v(" "), _c('p', {
    staticClass: "ML-BL1-last"
  }, [_vm._v("•  Cushion pad 14in (36cm) in diameter")])]), _vm._v(" "), _c('h2', {
    staticClass: "AHD"
  }, [_c('strong', [_vm._v("Finished Measurements")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("14in (36cm) diameter")]), _vm._v(" "), _c('h2', {
    staticClass: "AHD"
  }, [_c('strong', [_vm._v("Gauge")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("22 sts and 28 rows to 4in (10cm) measured over st st (1 row k, 1 row p) using size 6 (4mm) needles and A")]), _vm._v(" "), _c('h2', {
    staticClass: "AHD"
  }, [_c('strong', [_vm._v("Knit Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("This round pillow uses a larger version of the bolster ends to make two circular motifs that are then sewn together.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("Use two shades of purple, alternating them to make a pattern of concentric circles separated by a wonderful metallic purple yarn.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_c('strong', [_vm._v("Yarn C:")]), _vm._v(" Use two strands together throughout. Make sure that you work through both strands for each stitch.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("Transfer the work onto the circular needle when you have sufficient stitches.")]), _vm._v(" "), _c('h2', {
    staticClass: "AHD"
  }, [_c('strong', [_vm._v("Knit Your round Pillow")])]), _vm._v(" "), _c('h3', {
    staticClass: "BHD"
  }, [_c('strong', [_vm._v("FRONT AND BACK (MAKE 2)")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("Work rounds 1 to 28 as given for Bolster Ends, working rounds 11 and 12, 23 and 24 in C, and rounds 13 to 22 in B.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_c('strong', [_vm._v("Round 29")]), _vm._v(" Using A, k to end.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_c('strong', [_vm._v("Round 30")]), _vm._v(" Using A, *k6, kf&b; rep from * to end. 128 sts.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_c('strong', [_vm._v("Rounds 31, 32 and 33")]), _vm._v(" Using A, k to end.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_c('strong', [_vm._v("Round 34")]), _vm._v(" Using A, *k7, kf&b; rep from * to end. 144 sts.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_c('strong', [_vm._v("Rounds 35 and 36")]), _vm._v(" Using C, k to end.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_c('strong', [_vm._v("Round 37")]), _vm._v(" Using B, k to end.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_c('strong', [_vm._v("Round 38")]), _vm._v(" Using B, *k8, kf&b; rep from * to end. 160 sts.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_c('strong', [_vm._v("Rounds 39, 40 and 41")]), _vm._v(" Using A, k to end.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_c('strong', [_vm._v("Round 42")]), _vm._v(" Using B, *k9, kf&b; rep from * to end. 176 sts.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_c('strong', [_vm._v("Rounds 43, 44 and 45")]), _vm._v(" Using A, k to end.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_c('strong', [_vm._v("Round 46")]), _vm._v(" Using B, *k10, kf&b; rep from * to end. 192 sts.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_c('strong', [_vm._v("Rounds 47 and 48")]), _vm._v(" Using C, k to end.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_c('strong', [_vm._v("Round 49")]), _vm._v(" Using A, k to end.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_c('strong', [_vm._v("Round 50")]), _vm._v(" Using A, *k11, kf&b; rep from * to end. 208 sts.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_c('strong', [_vm._v("Rounds 51, 52 and 53")]), _vm._v(" Using A, k to end.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_c('strong', [_vm._v("Round 54")]), _vm._v(" Using A, *k12, kf&b; rep from * to end. 224 sts.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_c('strong', [_vm._v("Rounds 55, 56 and 57")]), _vm._v(" Using A, k to end.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("Bind off loosely.")]), _vm._v(" "), _c('h2', {
    staticClass: "AHD"
  }, [_c('strong', [_vm._v("Finish Your round Pillow")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("Sew in all ends neatly. Press according to instructions on ball bands. Sew the back to the front leaving a large gap. Insert cushion pad. Sew gap closed.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-428378c3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/c02.vue
// module id = 66
// module chunks = 0